import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { VerificationApplication } from "@models";
import { Observable } from "rxjs";
import { CountryDocument } from "@modules/verification/modal/entities/country-documents.model";

@Injectable({
	providedIn: "root"
})
export class VerificationModalRemote {
	public constructor(
		private readonly apicallService: ApicallService,
		private readonly masterdataService: MasterdataService
	) {}

	public getDocuments$(countryId: string): Observable<CountryDocument[]> {
		const countryISO = this.masterdataService.getCountryISO(countryId);
		return this.apicallService.get(`verification_documents/country_iso/${countryISO}`);
	}

	public getCitizenshipDocuments$(countryId: string): Observable<CountryDocument[]> {
		const countryISO = this.masterdataService.getCitizenshipCountryISO(countryId);
		return this.apicallService.get(`verification_documents/country_iso/${countryISO}`);
	}

	public getVerificationMethods$(
		document: string,
		countryId: string,
		language: string
	): Observable<VerificationApplication[]> {
		const apiOptions = new ApicallOption(VerificationApplication, {
			document_type: document,
			country_iso: this.masterdataService.getCitizenshipCountryISO(countryId),
			language: language,
			platform: "web"
		});
		return this.apicallService.post("verification-methods", apiOptions);
	}

	public startVerification$(
		selectedVerification: VerificationApplication,
		lang: string
	): Observable<VerificationApplication[]> {
		return this.apicallService.get(
			"verification/" + selectedVerification.getName() + "/" + lang,
			new ApicallOption(VerificationApplication)
		);
	}
}
